import { MCAP_MAGIC } from '@/features/mcap/config/preflight';

export async function hasMcapMagic(file: File): Promise<boolean> {
  if (file.size < MCAP_MAGIC.length * 2) return false;
  const [prefixBuffer, suffixBuffer] = await Promise.all([
    file.slice(0, MCAP_MAGIC.length).arrayBuffer(),
    file.slice(file.size - MCAP_MAGIC.length).arrayBuffer(),
  ]);
  const matches = (bytes: Uint8Array) => MCAP_MAGIC.every((value, index) => bytes[index] === value);
  return matches(new Uint8Array(prefixBuffer)) && matches(new Uint8Array(suffixBuffer));
}

export function makeSubmissionId(now = Date.now()): string {
  const bytes = crypto.getRandomValues(new Uint8Array(6));
  const nonce = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `up-${nonce}-${now}`;
}
